export default "__VITE_ASSET__kto$5StU__"